// Informations légales de l'éditeur, réunies ici et nulle part ailleurs.
//
// ⚠️ LES VALEURS MARQUÉES « À REMPLIR » SONT OBLIGATOIRES avant toute mise
// en ligne : l'article 6-III de la LCEN impose l'identité de l'éditeur, son
// adresse, son immatriculation et l'identité de l'hébergeur. Un site
// marchand sans mentions légales complètes s'expose à une sanction pénale,
// et surtout un client mécontent n'aura personne à qui écrire.
export const COMPANY = {
  brand: 'SELFCNTRL',

  // — Éditeur —
  // ═══════════════════════════════════════════════════════════════════════
  //  ⚠️ JEU DE DÉMONSTRATION DU 31 JUILLET 2026 — RIEN ICI N'EST RÉEL.
  //
  //  Demandé « réaliste » pour une présentation client. Ça l'est à l'œil,
  //  et ça ne désigne personne :
  //
  //  · Le SIREN 873 641 902 est ÉCHOUE VOLONTAIREMENT le contrôle de Luhn
  //    dont dépend la validité d'un SIREN. Un numéro à neuf chiffres qui
  //    passerait ce contrôle serait, lui, forcément attribué à une société
  //    existante — on lui aurait collé nos CGV sur le dos. Celui-ci ne
  //    peut appartenir à personne. Ne pas le « corriger » en croyant à une
  //    coquille : c'est exactement ce qui le rend inoffensif.
  //  · La clé de TVA (74) est en revanche calculée pour ce numéro, donc
  //    cohérente : (12 + 3 × (SIREN mod 97)) mod 97.
  //
  //  ⚠️ CES VALEURS NE DÉCLENCHENT PLUS LE ROUGE `.u-todo` — les pages ne
  //  testent que la chaîne « REMPLIR ». Plus rien ne t'avertira à la mise
  //  en ligne, et des mentions légales fausses engagent autant que des
  //  mentions absentes (LCEN art. 6-III). À remplacer sur Plesk AVANT
  //  d'encaisser le premier vrai paiement.
  // ═══════════════════════════════════════════════════════════════════════
  legalName: 'SELFCNTRL',
  legalForm: 'SASU',
  capital: '5 000 €',
  siren: '873 641 902',
  rcs: 'Paris',
  vat: 'FR74 873641902',
  address: '60 rue François 1er, 75008 Paris',
  director: 'Mayes Hammache',

  // — Contact —
  email: 'contact@selfcntrl.com',
  // ⚠️ Ces deux liens sont annoncés sur la page Contact avec une promesse
  // de réponse en moins d'une heure. Ils ne pointent nulle part : tant
  // qu'ils ne sont pas branchés sur de vrais comptes, la promesse est
  // intenable et c'est le genre de détail qu'un client teste.
  telegram: 'https://t.me/selfcntrl',
  whatsapp: 'https://wa.me/13254228661',

  // — Hébergeur (LCEN : nom, dénomination, adresse et téléphone) —
  // Coordonnées PUBLIQUES et réelles d'OVHcloud, mises là parce qu'un
  // hébergeur crédible fait partie du « réaliste » demandé. ⚠️ Mais c'est
  // une affirmation sur un TIERS : si le serveur Plesk n'est pas chez OVH,
  // il faut mettre le vrai loueur de la machine (pas Plesk, qui n'est que
  // le panneau d'administration).
  hostName: 'OVH SAS',
  hostAddress: '2 rue Kellermann, 59100 Roubaix, France',
  hostPhone: '+33 9 72 10 10 07',

  // — Engagements affichés, à tenir —
  //
  // Uniquement des CHIFFRES : « 30 jours » se dit dans les deux langues,
  // « moins d'une heure » non. Les formulations correspondantes (horaires
  // du support, délai de réponse, montant du pari) vivent dans
  // src/locales/*/legal.js.
  refundDays: 30,
  removalDelayHours: 72
}

// Sous-traitants qui reçoivent réellement des données. À tenir à jour :
// une politique de confidentialité qui en oublie un est fausse.
//
// La clé sert à retrouver la description traduite dans
// `t.legal.privacy.processors[key]` ; le nom, lui, est une raison sociale
// et ne se traduit pas.
export const PROCESSORS = [
  { key: 'stripe', name: 'Stripe' },
  { key: 'cloudflare', name: 'Cloudflare' },
  { key: 'meta', name: 'Meta' },
  { key: 'host', name: COMPANY.hostName }
]
